function generateSmartTicks (start, end) {
    const ticks = [];
    const startDate = new Date(start);
    const endDate = new Date(end);

    const rangeMs = end - start;
    const rangeHours = rangeMs / (1000 * 60 * 60);
    const rangeDays = rangeHours / 24;

    let stepHours;

    if (rangeHours <= 6) {
        stepHours = 1;            // hasta 6h → cada hora
    } else if (rangeHours <= 24) {
        stepHours = 2;            // 1 día → cada 2h
    } else if (rangeDays <= 2) {
        stepHours = 6;            // 2 días → cada 6h
    } else if (rangeDays <= 7) {
        stepHours = 24;           // hasta 1 semana → diario
    } else if (rangeDays <= 14) {
        stepHours = 48;           // 2 semanas → cada 2 días
    } else {
        stepHours = 72;           // rangos grandes → cada 3 días
    }

    // ⏱️ Alinear al “valor bonito”
    const current = new Date(startDate);
    current.setMinutes(0, 0, 0);

    if (stepHours >= 24) {
        current.setHours(0);
    }

    while (current <= endDate) {
        ticks.push(current.getTime());
        current.setHours(current.getHours() + stepHours);
    }

    return ticks;
};

function downsample(data, maxPoints = 400) {
    if (data.length <= maxPoints) return data;
    const step = Math.ceil(data.length / maxPoints);
    return data.filter((_, i) => i % step === 0 || i === data.length - 1);
}

export { generateSmartTicks, downsample };